<template>
  <details-sheet :item="inhabitant" :headers="headers" v-bind="$attrs">
    <template v-slot:item.building_complex="{ item }">
      <span>{{ buildingComplex.name }}</span>
      <v-btn v-if="buildingComplex.id" class="float-right" small icon :to="to">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </details-sheet>
</template>

<script>
import DetailsSheet from '@/modules/_global/_components/DetailsSheet.vue';
import { get } from 'lodash';

export default {
  name: 'BuildingComplexDetails',

  components: {
    DetailsSheet
  },

  props: {
    inhabitant: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex'
        },
        {
          text: this.$t('BUILDINGS.ITEM'),
          value: 'apartment.building.name'
        },
        {
          text: this.$t('APARTMENTS.ITEM'),
          value: 'apartment.name'
        },
        {
          text: this.$t('APARTMENTS.FLOOR'),
          value: 'apartment.floor'
        }
      ];
    },

    buildingComplex() {
      return get(this.inhabitant, 'apartment.building.building_complex', {});
    },

    to() {
      return {
        name: 'building_complexes.show',
        params: { id: this.buildingComplex.id }
      };
    }
  }
};
</script>

<style lang="scss">
.service-details {
  & &__title,
  & &__item {
    display: block;
    margin-bottom: 1rem;
  }

  & &__item {
    font-size: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & &__item-name {
    margin-right: 0.4rem;
  }
}
</style>
